var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workspace-list--tab"},[_c('workspace-list-tab-template',{attrs:{"lists":_vm.userLists},on:{"updateList":_vm.updateLists}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }